import React from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';

import { ClosedX } from './StyledOpen';

const StyledNav = styled.nav`
	${tw`w-full mx-auto fixed z-50 flex items-center`};
	&.notHome {
		box-shadow: rgba(0, 0, 0, 0.09) -4px 7px 8px 0px;
		border-bottom: 3px solid rgb(96, 2, 119);
	}
	height: 7rem;
	margin-bottom: -7rem;
	background-image: linear-gradient(-33deg, #8500a3 0%, #7d009f 100%);
`;

const Logo = styled.div`
	${tw`fixed z-50 flex items-center text-white font-round`};
	#⭐️ {
		transition: ease all 0.2s;
	}
	&:hover {
		#⭐️ {
			fill: rgb(167, 228, 235);
			fill: url(#wow);
		}
	}
	left: 30px;
	font-size: 2.625rem;
	.sophia-zey {
		margin-top: 4px;
		margin-left: 23px;
		display: none; //fix this later, make it display on all but homepage
	}
	span {
		${tw`font-blackout block`};
		font-size: 3.125rem;
		margin-top: -0.25em;
	}
`;

const Burger = styled.div`
	${tw`fixed font-heavy text-white text-32 z-50 cursor-pointer`};
	top: 39px;
	right: 30px;
	&:hover {
		${tw`text-secondary-light`};
	}
`;

const Menu = styled.div``;

const OpenSesame = styled.ul`
	${tw`ml-0 pl-0 fixed pin-t pin-b pin-l pin-r bg-primary h-screen w-screen flex z-40 text-center list-reset flex-col justify-center`};
	animation: fade-in 0.5s ease;

	li {
		${tw`my-3`};
		&:before {
			display: none !important;
		}
	}

	@keyframes fade-in {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
`;

const Styledlink = styled(Link)`
	${tw`font-blackout text-32 sm:text-64 text-white hover:text-grey-light no-underline`};
	transition: ease all 0.2s;
	&:hover {
		animation: flicker 2.5s infinite alternate;
	}
`;

export default class Header extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
		};
		this.go = this.go.bind(this);
	}

	go() {
		this.setState({ open: false });
	}

	render() {
		const { open } = this.state;
		const { isIndex } = this.props;
		return (
			<StyledNav className={`${!isIndex ? 'notHome' : ''}`}>
				<Logo>
					<Link to="/">
						<svg width="60px" height="56px" viewBox="0 0 60 56" version="1.1" xmlns="http://www.w3.org/2000/svg">
							<desc>Created with Sketch.</desc>
							<defs />
							<linearGradient id="wow" gradientTransform="rotate(45)">
								<stop stopColor="#FF0CB8" />
								<stop stopColor="#6BBECE" offset="1" />
							</linearGradient>
							<g id="🦄" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
								<g id="⭐️" transform="translate(-109.000000, -70.000000)" fill="#FFFFFF" fillRule="nonzero">
									<g id="Group" transform="translate(109.000000, 70.000000)">
										<path
											d="M13.3663366,53.3168317 C7.07551109,50.9064526 3.16462,46.7975417 1.63366337,40.990099 C-0.445544554,33.5643564 -0.445544554,28.3168317 1.63366337,25.2475248 C3.02757712,23.1898425 8.71367141,18.369051 16.4108911,12.3267327 C18.9336965,10.3463302 23.8668198,8.19071126 31.210261,5.85987599 C32.8448921,4.48284213 34.1459808,3.45666966 35.1135271,2.78135859 C36.5648466,1.76839197 40.815938,0.183835069 41.8048404,1.18811881 C42.7937428,2.19240255 40.7515781,5.85987599 40.7515781,8.78052071 C41.557014,9.64882049 41.3481803,9.52302684 41.8048404,10.2475248 C42.3653975,9.77140303 58.9619014,-1.11948108 59.5244292,0.148514851 C60.3298651,1.96405076 52.8950726,10.2013749 48.3102838,16.4373461 C53.7005084,21.1735267 57.9135575,26.2649208 59.5244292,29.9354608 C60.2059519,31.8299331 59.9389484,33.6286508 59.2574257,35.049505 C59.0543319,35.4729196 57.6752514,36.8961256 56.1386139,37.5742574 C54.8256925,38.1536613 53.6356499,38.2250846 53.019802,38.019802 C51.6831683,37.5742574 50.899491,37.2673948 50.1980198,36.5346535 C49.0546101,35.340273 48.5864209,33.8613861 48.3102838,33.8613861 C47.8647393,33.8613861 46.9137218,34.951426 47.8217822,36.2376238 C48.6982008,37.4790035 50.4950495,37.5742574 50.4950495,38.4653465 C50.4950495,39.3564356 48.0769666,38.6687938 47.5247525,38.4653465 C44.7029703,37.4257426 44.1089109,36.980198 42.7722772,36.5346535 C41.4356436,36.0891089 34.8331978,33.203473 33.5643564,35.2241959 C32.295515,37.2449187 31.210261,44.1089109 31.2059044,46.9306931 C31.2015478,49.7524752 31.210261,53.7623762 29.7029703,54.6534653 C26.89499,56.3135039 21.0028546,56.2428234 13.3663366,53.3168317 Z M44.1089109,20.049505 C44.3344725,19.908529 44.5544554,19.6039604 44.5544554,19.3069307 C44.5544554,19.009901 43.7879727,16.2322289 42.029703,15.8910891 C40.2714333,15.5499494 39.1990306,16.4940387 38.6138614,17.0792079 C38.019802,17.6732673 37.7227723,18.5643564 38.3168317,18.8613861 C38.9108911,19.1584158 39.2079208,18.4158416 39.6534653,17.8626224 C40.0990099,17.3094032 40.935135,16.9754419 41.8811881,17.2277228 C42.8272412,17.4800036 43.0693069,19.4554455 43.2178218,19.7524752 C43.3663366,20.049505 43.8833493,20.1904809 44.1089109,20.049505 Z"
											id="Combined-Shape"
										/>
									</g>
								</g>
							</g>
						</svg>
					</Link>
					<div className="sophia-zey">
						SOPHIA<span>ZEY</span>
					</div>
				</Logo>
				<Menu>
					<ClosedX onClick={() => this.setState({ open: !this.state.open })}>
						<Burger className={`hamburger ${open ? 'change' : ''}`}>MENU</Burger>
					</ClosedX>
					{open && (
						<OpenSesame>
							{/* <li>
								<Styledlink onClick={this.go} to="/">
									Home
								</Styledlink>
							</li> */}
							<li>
								<Styledlink onClick={this.go} to="/now">
									Now
								</Styledlink>
							</li>
							<li>
								<Styledlink onClick={this.go} to="/about">
									About
								</Styledlink>
							</li>
							<li>
								<Styledlink onClick={this.go} to="/music">
									Music
								</Styledlink>
							</li>
							<li>
								<Styledlink onClick={this.go} to="/blog">
									Blog
								</Styledlink>
							</li>
							<li>
								<Styledlink onClick={this.go} to="/contact">
									Contact
								</Styledlink>
							</li>
						</OpenSesame>
					)}
				</Menu>
			</StyledNav>
		);
	}
}
